import * as _ from 'underscore';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import * as appTheme from './appTheme';
import { WidgetData } from './WidgetData';
import { WidgetBase } from './WidgetBase';
import { IWorkspaceData } from '../../../pdc-platform/src/ts/stores/WorkspaceStore';
import { IWidget } from '../../../pdc-platform/src/ts/Interfaces';
import { normalizeLayout } from '../../../pdc-platform/src/tsx/layout/gridLayout';

function normalizeWidget(data, glob) {
    const Widget = WidgetBase.getConstructorByName(data.type);

    if (Widget == null) {
        return data;
    }

    return WidgetData.normalizeForSaveData(data, glob);
}

function serializeWidget(widget: IWidget, normalizeWidgets?, glob?) {
    widget = { ...widget };

    if (normalizeWidgets) {
        widget = normalizeWidget(widget, glob);
    }

    widget.values = _.mapObject(widget.values, (val, key) => {
        val = _.clone(val);

        if (val.theme != null) {
            val.theme = appTheme.clearMapObj(val.theme);
        }

        return val;
    });

    const widgetType = widget.type;

    if (widget.values[widgetType] != null) {
        const childWidgets = widget.values[widgetType].widgets;

        widget.values[widgetType].widgets = _.map(childWidgets, (w: any) => {
            return serializeWidget(w, normalizeWidgets, glob);
        });
    }

    return widget;
}

export default function serializeWorkspace(
    data: IWorkspaceData,
    toSaveData: boolean,
    normalizeWidgets?: boolean,
    glob?: IGlob
) {
    if (data == null) {
        return 'null';
    }

    data = { ...data };

    if (toSaveData) {
        if (data.layout != null) {
            data.layout = normalizeLayout(data.layout);
        }
    }

    if (data.theme != null) {
        data.theme = appTheme.clearMapObj(data.theme);
    }

    data.widgets = _.map(data.widgets, (widget) => {
        return serializeWidget(widget, normalizeWidgets, glob);
    });

    delete data.widgetsLocal;

    return JSON.stringify(data);
}
